import { render, staticRenderFns } from "./SystemInfo.backup.vue?vue&type=template&id=6aeaf611&"
import script from "./SystemInfo.backup.vue?vue&type=script&lang=js&"
export * from "./SystemInfo.backup.vue?vue&type=script&lang=js&"
import style0 from "./SystemInfo.backup.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports